<script>
	import { Modal } from "../stores/modal";
	import Preload from '../../utils/preload';
	import { fly, fade } from 'svelte/transition';

	let data;

	Modal.subscribe(m => {
		data = m.data;
	})
</script>
<svelte:head>
	
	{#if $Modal.opened}
		<style>
			body {
				overflow: hidden;
			}
		</style>
	{/if}
</svelte:head>
{#if $Modal.opened}
	{#await Preload('/images/pattern2.png')}
		<span></span>
	{:then base64}
		<div class="modal" tabindex="-1" role="dialog" transition:fade={{duration: 400}}>
			<div class="for-modal-close" on:click|preventDefault={Modal.close}></div>
			<div class="modal-dialog" role="document">
				<div class="modal-content bg-alt">
					{#if $Modal.data.title}
						<div class="modal-header">
							<h5 class="modal-title text-center">{$Modal.data.title}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" on:click|preventDefault={Modal.close}>
								<img src="/images/x_mark.png" alt="Close" class="close-icon close-icon-active">
							</button>
						</div>
					{/if}
					<div class="modal-body">
						<svelte:component this={$Modal.component} data={$Modal.data}/>
					</div>
					{#if data.actions && data.actions.length > 0}
						<div class="modal-footer">
							{#each data.actions as action}
								<button type="button" class="btn btn-{action.type ? action.type : 'default'}" on:click|preventDefault={e => {
									if(action.close){
										Modal.close();
									}else{
										action.action();
									}
								}}>{data.title}</button>
							{/each}
						</div>
					{/if}
				</div>
			</div>
		</div>
	{/await}
{/if}
<style lang="scss">
	.modal{
		display: block;
		background-color: #00000099;
	}

	h5 {
		// margin-top: 20px;
		font-size: 16px;
		font-weight: 600;
		font-family: var(--primary-font);
	}

	.modal-body {
        color: #000;
		max-height: calc(95vh - 100px);
		overflow-y: auto;
		// max-height: calc(100vh - 100px);
		// overflow-y: auto;
	}

	.for-modal-close {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
	}

	.modal-dialog {
		border: 5px solid var(--primary);
		position: relative;
		border-radius: 34px;
	}

	.modal-dialog::before {
		// content: "";
		// position: absolute;
		// left: 8px;
		// right: 8px;
		// bottom: 8px;
		// top: 8px;
		// border: 2px solid var(--primary);
		// z-index: 1;
		// border-radius: 13px;
	}

	.modal-header {
		justify-content: center;
		z-index: 1;
	}

	.modal-header .close {
		position: absolute;
		position: absolute;
		right: 15px;
		top: 15px;
	}

	.modal-content {
		position: relative;
		height: 100%;
		background: transparent;
	}

	.close-icon {
		width: 24px;
		height: 24px;
	}

	.modal-content::before {
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background-image: url(/images/pattern2.png);
		opacity: 1;
		background-repeat: repeat;
		border-radius: 10px;
		overflow: hidden;
	}

	.close {
		opacity: 1;
	}
</style>